import type { INavData } from '@coreui/angular-pro';

export const navItemsAdmin: INavData[] = [
  /*{
    name: 'Home',
    url: '/dashboard',
    iconComponent: { name: 'cil-home' },
  },*/
  {
    name: 'Pacientes',
    url: '/patient',
    iconComponent: { name: 'cil-people' },
    children: [
      {
        name: 'Listado de pacientes',
        url: '/patient/list',
      },
    ],
  },
  {
    name: 'Órdenes ERKOM',
    iconComponent: { name: 'cil-clipboard' },
    url: '/erkom/list',
  },
  {
    name: 'Usuarios',
    url: '/users',
    iconComponent: { name: 'cil-user' },
  },
  {
    name: 'Estudios',
    url: '/studies',
    iconComponent: { name: 'cil-clipboard' },
  },
];
